<template>
  <div>
    <MainNavigation page-name="My Class" :routeIndex="routeIndex" />
    <NotificationBar msg-text="Select “Create New Session” to start a game" />
    <div>
      <h1>Class Info</h1>
    </div>
    <Loader v-if="!currentClass" />
    <section v-if="currentClass">
      <ClassItem
        v-if="currentClass"
        :editMode="false"
        :classItem="currentClass"
        :itemType="'static'"
      />
      <div class="sessions-container">
        <h2>Sessions</h2>
        <button
          v-if="pastSessionsCount"
          @click="viewPastSession()"
          style="margin-bottom: 1rem"
          class="past-sessions"
        >
          View Past Sessions ({{ pastSessionsCount }})
        </button>
        <button @click="createNewSession()" class="new-session">
          Create New Session
        </button>
        <p>
          Students will be able to join teams as soon as you create a new
          session
        </p>
        <hr />
      </div>
      <div class="student-list-container">
        <div class="edit-student-list-container">
          <h2>Students ({{ currentClass.studentList.length }})</h2>
          <button
            style="width: fit-content; padding: 0rem 1.5rem"
            @click="editList"
          >
            Edit List
          </button>
        </div>
        <ul class="student-list">
          <li
            v-for="student in currentClass.studentList"
            style="white-space: pre-line"
            :key="student.studentId"
          >
            <span v-if="student.studentNickname == ''">
              {{ displayName(student) }}
            </span>
            <span v-else>
              {{ displayName(student) }} ({{ student.studentNickname }})
            </span>
          </li>
        </ul>
        <!-- <hr />
         <div class="timestamp">
          Class created on June 24, 2021
          <br />
          Last session on June 26, 2021
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
import MainNavigation from "../components/MainNavigation.vue";
import NotificationBar from "../components/NotificationBar.vue";
import Loader from "../components/Loader.vue";
import ClassItem from "../components/ClassItem.vue";

export default {
  name: "StudentListAdded",
  components: {
    MainNavigation,
    NotificationBar,
    Loader,
    ClassItem,
  },
  props: ["name", "routeIndex"],
  computed: {
    allClasses() {
      return this.$store.state.allClasses;
    },
    dataUpdated() {
      return this.$store.state.dataUpdated;
    },
    userType() {
      return this.$store.state.userType;
    },
    currentClass() {
      for (let i = 0; i < this.$store.state.allClasses.length; i++) {
        const thisClass = this.$store.state.allClasses[i];
        if (thisClass.classInfo.nickname == this.$route.params.name) {
          this.$store.commit(
            "SET_CURRENT_CLASS",
            this.$store.state.allClasses[i]
          );
          return this.$store.state.allClasses[i];
        }
      }
      return {
        classId: null,
        classInfo: {
          nickname: null,
          checkedDay: [],
          grade: null,
          subject: null,
        },
        studentList: [],
      };
    },
    allStudents() {
      return this.currentClass.studentList;
    },
    classColor() {
      if (!this.currentClass || this.currentClass == null) return "white";
      else return this.$filters.colorAssign(this.currentClass.classId);
    },
    pastSessionsCount() {
      return this.$store.state.pastSessionsCount;
    },
  },
  methods: {
    displayName(student) {
      if (student.studentName && student.studentName.trim() !== '') {
        return student.studentName;
      }
      return `${student.studentFirstName} ${student.studentLastInitial}`;
    },
    createNewSession: function () {
      this.$store.commit("SEND_MESSAGE", {
        data: {
          classId: this.currentClass.classId,
          teacherId: this.$store.state.teacherId,
        },
        opCode: this.$store.state.opCodes.CreateNewSession,
      });
      this.$router.push({
        name: "new-session",
      });
    },
    editList: function () {
      this.$router.push({
        name: "edit-student-list",
        params: { name: this.currentClass.classInfo.nickname },
      });
    },
    viewPastSession: function () {
      this.$store.commit("SEND_MESSAGE", {
        data: this.currentClass.classId,
        opCode: this.$store.state.opCodes.PastSessionsBrief,
      });
      this.$router.push({
        name: "past-sessions",
        params: { name: this.currentClass.classInfo.nickname },
      });
    },
  },
};
</script>

<style lang="scss">
.edit-student-list-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sessions-container {
  button {
    width: 100%;
    &.past-sessions {
      background: $beige;
      border: 4px solid $red;
      color: $red;
    }
  }
}

.student-list-container {
  .student-list {
    margin: 0 0 2rem 0;
    li {
      margin-bottom: 1em;
    }
  }
}

.past-session {
  margin-bottom: 1.5rem;
  background: #fff;
  color: #000;
  border: solid #000 1px;
}
</style>